/*
 * Copyright © 2020-2025 Ocean Galaxy Inc. All Rights Reserved.
 * @Description:
 * @LastEditors: yongqiang
 * @LastEditTime: 2025-11-03 17:32:45
 */
import { createSlice, PayloadAction } from '@reduxjs/toolkit'

interface GroupLimitState {
  limitInfo: null | {
    isLimit: boolean //是否达到成员限制
    peopleNum: number //当前成员数
    peopleLimitNum: number //成员限制数
    vipKind: number //vip类型
    isVIP: boolean //是否是vip
    photoViewLimit: {
      exist: boolean //是否达到照片查看限制
      day: number //照片查看限制天数
    }
  }
}

const initialState: GroupLimitState = {
  limitInfo: null
}

const groupLimitSlice = createSlice({
  name: 'groupLimit',
  initialState,
  reducers: {
    setGroupLimitInfo: (
      state,
      action: PayloadAction<GroupLimitState['limitInfo']>
    ) => {
      state.limitInfo = action.payload
    }
  }
})

export const { setGroupLimitInfo } = groupLimitSlice.actions

export default groupLimitSlice.reducer
